import { isDefined } from './index.js';
const PARAMETERS_REGEX = /[:{]([A-Za-z][A-Za-z\d_]*)(?=[^}]*})?/g;
function matchObjectByKeys(keys, obj) {
    const diffObj = { ...obj };
    const matchObj = keys.reduce((accumulator, key) => {
        const value = diffObj[key];
        if (isDefined(value)) {
            const result = { ...accumulator, [key]: value };
            delete diffObj[key];
            return result;
        }
        return accumulator;
    }, {});
    return [matchObj, diffObj];
}
function createURLSearchParams(params) {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params ?? {})) {
        if (Array.isArray(value)) {
            value.forEach(item => searchParams.append(key, item));
        }
        else {
            searchParams.append(key, String(value));
        }
    }
    return searchParams;
}
function resolvePath(path, params) {
    return Object.keys(params).reduce((current, key) => {
        return current.replace(new RegExp(`[:{]${key}([^\\w]|$)`, 'g'), (_, p1) => params[key] + p1.replace('}', ''));
    }, path);
}
function getPathParams(path) {
    const params = path.match(PARAMETERS_REGEX);
    if (params) {
        return params.map((param) => param.replace(/[:{}]/g, ''));
    }
    return [];
}
function isPathReady(path) {
    return !path.match(PARAMETERS_REGEX);
}
function getResolvedPathAndParameters(path, parameters = {}) {
    const pathParamNames = getPathParams(path);
    const [pathParams, queryParams] = matchObjectByKeys(pathParamNames, parameters);
    const resolvedPath = resolvePath(path, pathParams);
    return {
        pathParams,
        queryParams,
        resolvedPath,
    };
}
export { createURLSearchParams, getPathParams, getResolvedPathAndParameters, isPathReady, resolvePath, };
//# sourceMappingURL=url.js.map